/** Fallback when the agency has not configured a session timeout. */
export const DEFAULT_SESSION_TIMEOUT_MS = 600000;

/** How long the warning shows before the session actually ends. */
export const SESSION_WARNING_MS = 60000;

/**
 * Resolve the idle timeout from the agency's configured `sessionTimeoutMins`
 * — WCAG 2.1 SC 2.2.1 Timing Adjustable.
 *
 * The value is already fetched by the agency query on every authenticated
 * route and was consumed by nothing: the timeout was a hardcoded ten minutes.
 * A null, absent, zero or negative value falls back rather than producing an
 * instant or infinite timeout.
 */
export const resolveIdleTimeoutMs = (
  sessionTimeoutMins: number | null | undefined,
): number =>
  typeof sessionTimeoutMins === "number" && sessionTimeoutMins > 0
    ? sessionTimeoutMins * 60000
    : DEFAULT_SESSION_TIMEOUT_MS;

/**
 * How long before the deadline to warn. Never more than half the timeout — on
 * a short agency-configured timeout a fixed 60s warning could otherwise start
 * before the participant had finished reading anything.
 */
export const resolveWarningMs = (idleTimeoutMs: number): number =>
  Math.min(SESSION_WARNING_MS, Math.floor(idleTimeoutMs / 2));
